/* eslint-disable no-cond-assign */

import { ProposalDAOInterface } from '../ProposalDAO';
import { ComparisonItemBasedProposalDAO } from '../ProposalDAOImpl';
import { ProposalFieldDAO } from '../ProposalFieldDAO';
import * as ProposalNS from '../../Proposal';
import * as ProposalElementNS from '../../ProposalElements';
import { DataPoints, DataPointResponse } from '../DataPoints';
import { ProposalStyleClassNames } from '../../ProposalStyleClassNames';
import { GrowthCell } from '../../../../views/components/cells';
import TimePeriods from '@/types/time-periods';
import BestWorstMetric from '@/types/best-worst-metric';

export default class BestWorstDAO extends ComparisonItemBasedProposalDAO {
  public static buildInstance(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement): ProposalDAOInterface {
    return new BestWorstDAO(proposal, proposalElement);
  }

  /* eslint-disable-next-line class-methods-use-this */
  protected getColorKeys(): string[] {
    return ['BEST_WORST_COLORS'];
  }

  protected build(): void {
    const daoConfig: ProposalNS.BestWorstConfig = this.proposalElement.DAO as ProposalNS.BestWorstConfig;
    const period: TimePeriods = daoConfig.period !== undefined ? daoConfig.period : '10Y';
    const interval: TimePeriods = daoConfig.interval !== undefined ? daoConfig.interval : '1Y';

    let itemDAO = null;
    while ((itemDAO = this.nextItem()) !== null) {
      const dpResponse: DataPointResponse<BestWorstMetric> = DataPoints.getBestWorstPerformance(
        itemDAO.item,
        period,
        interval,
        this.proposal.showBaseCurrencies === true,
      );
      this.addDisclaimerKeys(dpResponse.disclaimerKeys, itemDAO.item);

      const labelBest: string = this.formatMessage('Proposal.Best');
      const fieldBest = new ProposalFieldDAO(labelBest, dpResponse.response.best.value, ProposalStyleClassNames.ProposalTableContent);
      fieldBest.cellType = GrowthCell;
      this.addFieldDAO(itemDAO, fieldBest);
      this.addFieldName(labelBest, ProposalStyleClassNames.ProposalTableContent);

      const labelWorst: string = this.formatMessage('Proposal.Worst');
      const fieldWorst = new ProposalFieldDAO(labelWorst, dpResponse.response.worst.value, ProposalStyleClassNames.ProposalTableContent);
      fieldWorst.cellType = GrowthCell;
      this.addFieldDAO(itemDAO, fieldWorst);
      this.addFieldName(labelWorst, ProposalStyleClassNames.ProposalTableContent);
    }
  }
}
